import React from 'react'
import { useLocation } from 'react-router-dom'
import HeaderDesktop from './header-desktop/HeaderDesktop'
import HeaderMobile from './header-mobile/HeaderMobile'
import type { LanguageTokens } from 'i18n'
import { WrapperFopDesktopScreen } from './HeaderModular.styles'

type HeaderModularProps = {
  title?: LanguageTokens
  pathGoBack?: string
}

const HeaderModular: React.FC<HeaderModularProps> = ({ title, pathGoBack }) => {
  const location = useLocation()
  const isAdminRoute = location.pathname.includes('admin')

  return (
    <header id="header-modular" className="z-6">
      <WrapperFopDesktopScreen isFixed={isAdminRoute}>
        <HeaderDesktop />
      </WrapperFopDesktopScreen>
      <HeaderMobile title={title} pathGoBack={pathGoBack} />
    </header>
  )
}

export default HeaderModular
